import { GOODS_TYPES } from 'constants/sales'
import htmlDecode from 'utils/htmlDecode'

const PRODUCT_NAME_FALLBACKS = {
  [GOODS_TYPES.dnaConsultation]: 'Консультация генетика',
  [GOODS_TYPES.nutritionConsultation]: 'Консультация нутрициолога',
}

export const getCartLabels = (
  cart,
  dict,
  cartDict,
  sales,
  costCalculate = num => num,
) => {
  const lineItems = []
  const {
    biome,
    dna,
    wgs,
    [GOODS_TYPES.dnaConsultation]: dnaConsultation,
    [GOODS_TYPES.nutritionConsultation]: nutritionConsultation,
  } = cart.goods
  const salesGoods = sales?.goods || {}

  const getProductTitle = productType => {
    const localizedTitle = dict.kits?.[productType]?.title

    if (localizedTitle) {
      return htmlDecode(localizedTitle).replace(/<w?br\s*\/?>/gi, '')
    }

    return salesGoods[productType]?.name || PRODUCT_NAME_FALLBACKS[productType] || productType
  }

  const getLabelsItem = (product, productType, dictCode = productType) => {
    const count =
      product.amount > 1 ? `— ${product.amount} ${cartDict.payment.items}` : ''
    const subTitle = `(${dict.kits[
      dictCode
    ].types?.subscription.title.toLowerCase()})`
    const subscription = product.isSubscription ? subTitle : ''

    return {
      label: `${getProductTitle(productType)}${subscription} ${count}`.trim(),
      amount: costCalculate(product.cost),
    }
  }

  if (salesGoods.dna?.isActive && dna.cost) {
    lineItems.push(getLabelsItem(dna, GOODS_TYPES.dna))
  }

  if (salesGoods.wgs?.isActive && wgs.cost) {
    lineItems.push(getLabelsItem(wgs, GOODS_TYPES.wgs))
  }

  if (salesGoods.biome?.isActive && biome.cost) {
    lineItems.push(getLabelsItem(biome, GOODS_TYPES.biome))
  }

  if (salesGoods[GOODS_TYPES.dnaConsultation]?.isActive && dnaConsultation?.amount) {
    lineItems.push(
      getLabelsItem(
        dnaConsultation,
        GOODS_TYPES.dnaConsultation,
        GOODS_TYPES.dna,
      ),
    )
  }

  if (
    salesGoods[GOODS_TYPES.nutritionConsultation]?.isActive &&
    nutritionConsultation?.amount
  ) {
    lineItems.push(
      getLabelsItem(
        nutritionConsultation,
        GOODS_TYPES.nutritionConsultation,
        GOODS_TYPES.biome,
      ),
    )
  }

  if (cart.sum.delivery) {
    lineItems.push({
      label: cartDict.delivery.row_title,
      amount: costCalculate(cart.sum.delivery),
    })
  }

  return lineItems
}
